
import { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { Button } from "../components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-6">
      <div className="text-center space-y-6 max-w-md w-full animate-fade-in">
        <div className="flex justify-center">
          <div className="w-24 h-24 rounded-full bg-bytesplash-blue/10 flex items-center justify-center">
            <span className="text-5xl font-bold text-bytesplash-blue">404</span>
          </div>
        </div>
        
        <h1 className="text-3xl font-bold text-gray-800">Page not found</h1>
        <p className="text-gray-500">
          Sorry, we couldn't find the page you're looking for. The page might have been removed, renamed, or is temporarily unavailable.
        </p>
        
        <div className="pt-4">
          <Button asChild>
            <Link to="/" className="min-w-[150px]">
              Back to Dashboard
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
